import {
  AddShoppingCartOutlined,
  Cable,
  CallMadeOutlined,
  CallReceivedOutlined,
  Visibility,
  VisibilityOff,
  Wallet,
  WatchLater,
} from "@mui/icons-material";
import {
  Button,
  Chip,
  Container,
  Grid,
  IconButton,
  ListItemDecorator,
  Stack,
  Tab,
  tabClasses,
  TabList,
  TabPanel,
  Tabs,
  Typography,
  useColorScheme,
} from "@mui/joy";

import * as React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import HeaderMain from "../components/Headermain";
import { CurrencyFormat } from "../config/services";
import Activity from "./activity";
import AssetItems from "./assetitems";

export default function HomeIndex() {
  const navigate = useNavigate();
  const userinfo = useSelector((state) => state.useInfos);
  const walletData = useSelector((state) => state.walletsData);
  const [showbalance, setSahowbalance] = React.useState(true);
  const [index, setIndex] = React.useState(0);

  return (
    <>
      <gecko-coin-price-marquee-widget
        locale="en"
        dark-mode={useColorScheme().mode === "dark" ? "true" : "false"}
        transparent-background="true"
        coin-ids=""
        initial-currency="usd"
      ></gecko-coin-price-marquee-widget>
      <HeaderMain />
      <Container maxWidth="md">
        <Grid
          container
          direction="column"
          spacing={2}
          sx={{ flexGrow: 1 }}
          mt={2}
        >
          <Grid>
            <Stack direction="column" spacing={0}>
              <Stack direction={"row"} spacing={1} alignItems={"center"}>
                <Typography level="title-sm">Available balance</Typography>
                <IconButton
                  size="sm"
                  variant="plain"
                  color="neutral"
                  onClick={() => setSahowbalance(!showbalance)}
                >
                  {showbalance ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </Stack>

              <Typography level="h1">
                {showbalance ? (
                  <CurrencyFormat
                    amount={userinfo.totalBalance}
                    prefix={"$"}
                    seperator={true}
                  />
                ) : (
                  "* * * *"
                )}
              </Typography>
            </Stack>
          </Grid>

          <Grid>
            <Stack
              direction="row"
              spacing={2}
              useFlexGap
              flexWrap={"wrap"}
              sx={{
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {[
                {
                  title: "Buy",
                  path: "/buy",
                  icon: <AddShoppingCartOutlined fontSize="xl2" />,
                },

                {
                  title: "Send",
                  path: "/allcoin",
                  icon: <CallMadeOutlined fontSize="xl2" />,
                },
                {
                  title: "Receive",
                  path: "/receive",
                  icon: <CallReceivedOutlined fontSize="xl2" />,
                },
                {
                  title: "Connect",
                  path: "/connectwallet",
                  icon: <Cable fontSize="xl2" />,
                },
              ].map((button, index) => (
                <Button
                  startDecorator={button.icon}
                  key={index}
                  onClick={() => navigate(button.path)}
                  variant="solid"
                  color="primary"
                  size="lg"
                  sx={{ borderRadius: "16px" }}
                >
                  {button.title}
                </Button>
              ))}
            </Stack>
          </Grid>

          <Grid mt={2}>
            <Tabs
              size="lg"
              sx={{ backgroundColor: "transparent" }}
              aria-label="Pipeline"
              value={index}
              onChange={(event, value) => setIndex(value)}
            >
              <TabList
                sx={{
                  pt: 1,
                  justifyContent: "center",
                  [`&& .${tabClasses.root}`]: {
                    flex: "initial",
                    bgcolor: "transparent",
                    "&:hover": {
                      bgcolor: "transparent",
                    },
                    [`&.${tabClasses.selected}`]: {
                      color: "primary.plainColor",
                      "&::after": {
                        height: 2,
                        borderTopLeftRadius: 3,
                        borderTopRightRadius: 3,
                        bgcolor: "primary.500",
                      },
                    },
                  },
                }}
              >
                <Tab indicatorInset>
                  <ListItemDecorator sx={{ fontSize: "larger" }}>
                    <Wallet />
                  </ListItemDecorator>
                  Assets
                </Tab>

                <Tab indicatorInset>
                  <ListItemDecorator>
                    <WatchLater />
                  </ListItemDecorator>
                  Activity
                </Tab>
              </TabList>
              <TabPanel sx={{ padding: 0, mt: 3 }} value={0}>
                <AssetItems />
              </TabPanel>
              <TabPanel value={1}>
                <Activity />
              </TabPanel>
            </Tabs>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
